.header {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  background: var(--color-surface-glass);
  backdrop-filter: blur(1.25rem);
}

.container {
  max-width: 96rem;
  margin: 0 auto;
  padding: 0 2.5rem;
  display: flex;
  min-height: 4.5rem;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;

  nav a,
  nav > div,
  nav {
    height: 100%;
  }

  nav > div {
    align-items: center;
    gap: 2.25rem;
  }

  nav a {
    padding: 0;
    color: var(--color-foreground);
    font-size: 0.875rem;

    &:hover,
    &[data-active] {
      background: transparent;
      color: var(--color-primary);
    }
  }
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--color-foreground);
  transition: opacity 0.3s ease;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
}

.navArea {
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 1;
  justify-content: center;

  @media (max-width: 1000px) {
    display: none;
  }
}

.signInArea {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  height: 100%;
  padding: 0;
  flex-wrap: wrap;
}

@media (max-width: 900px) {
  .container {
    min-height: 4.5rem;
    padding: 0 1.25rem;
  }

}

@media (max-width: 480px) {
  .container {
    padding-right: max(1rem, env(safe-area-inset-right));
    padding-left: max(1rem, env(safe-area-inset-left));
    gap: 0.75rem;
    flex-wrap: wrap;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .signInArea {
    gap: 0.25rem;
    margin-inline-start: auto;
  }

}
